export default __webpack_public_path__ + "static/media/section1_background.7980b0ea.png";